window.$ = window.jQuery = require("jquery");

(function($) {
  $.fn.privacyIframe = function(options) {
    var config = $.extend({}, {
      text: 'Zum Aktivieren von Google Maps bitte hier klicken. Durch das Aktivieren von eingebetteten iFrames werden Daten an den jeweiligen Anbieter übermittelt. Weitere Informationen können unserer Datenschutzerklärung entnommen werden.',
      bgOdd: 'rgba(255,255,255,0.3)',
      bgEven: 'rgba(255,255,255,0.15)',
      padding: '50px'
    }, options);
    
    function showMessage($e) {
      var pos = $e.position();
      $message = $('<div/>')
        .width($e.width())
        .height($e.height())
        .css({top: pos.top, left: pos.left, position: 'absolute', padding: config.padding, cursor: 'pointer', background: 'repeating-linear-gradient(45deg, ' + config.bgOdd + ', ' + config.bgOdd + ' 20px, ' + config.bgEven + ' 20px, ' + config.bgEven + ' 40px)'})
        .text(config.text)
        .click(function() {
          $e.attr('src', $e.attr('data-src'));
          $(this).remove();
        });
      $message.insertAfter($e);

      $(window).resize(function() {
        $message
          .outerWidth($e.width())
          .outerHeight($e.height())
      });
    }
    
    this.each(function() {
      showMessage($(this));
    });
    
    return this;
  };


})(jQuery);